import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@bingads-webui-react/fabric-control';
import { Alert } from '@bingads-webui-react/alert';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ReactTemplate } from '@bingads-webui-react/react-template';

export const AIGCDisclaimer = (props) => {
  const {
    i18n,
  } = props;

  const classes = useDefaultStyles(() => ({
    AIGCDisclaimer: {
      marginBottom: '16px',
    },
    AIGCLink: {
      color: '#106ebe',
    },
  }));

  return (
    <div className={classNames(classes.AIGCDisclaimer, 'aigc-disclaimer')}>
      <Alert
        message={
          <ReactTemplate
            model={{
                a: text => (
                  <Link
                    href="https://about.ads.microsoft.com/en-us/policies/intellectual-property-policies"
                    className={classNames('aigc-info-text', classes.AIGCLink)}
                    target="_blank"
                    aria-label={i18n.getString(_TL_('Intellectual Property Policies (opens in a new tab)'))}
                  >
                    {`${text} `}
                  </Link>
                ),
              }}
            template={
                i18n.getString(_TL_('Please ensure you review any newly created images carefully. It\'s your responsibility to ensure that the images do not infringe upon any third-party rights, including copyright or other intellectual property rights. {{a}}Learn more{{/a}}'))
              }
          />
          }
        level="Info"
        icon={(<div className="alert-image" />)}
        dismissible={false}
      />
    </div>);
};


AIGCDisclaimer.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

AIGCDisclaimer.defaultProps = {
};
